'use client';
import React from 'react';
import { useRouter, useSearchParams } from 'next/navigation';

type VersionSelectProps = {
  versions: { revision: string; label: string }[];
};

function VersionSelect({ versions }: VersionSelectProps) {
  const router = useRouter();
  const searchParams = useSearchParams();

  const handleVersionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newRevision = e.target.value;
    const params = new URLSearchParams(searchParams.toString());
    params.set('revision', newRevision);
    router.push(`?${params.toString()}`);
  };

  return (
    <select
      id="version-select"
      onChange={handleVersionChange}
      className="w-1/3 rounded-lg border-2 border-solid border-[#d7d7d7] p-2"
    >
      {versions.map(version => {
        return (
          <option value={version.revision} key={version.revision}>
            {version.label}
          </option>
        );
      })}
    </select>
  );
}

export default VersionSelect;
